// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"8c5af919","328":"0009ff64"}[chunkId] + ".chunk.css";
};